'use client';
var getLineHeightByFontSize = function(size) {
    var order = Math.floor((size - 12) / 2) + 1;
    return size + 2 * order + 2;
};

export { getLineHeightByFontSize };
